









































































































import { Vue, Component, Prop, Emit, Ref, Watch } from 'vue-property-decorator';
import { inject } from 'inversify-props';
import { IStockService, IPatientService, IDrugService } from '@/interfaces/Services';
import { required } from '@/utils/validation';
import { PatientModel } from '@/models/patient';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { DrugModel } from '../../models/drug';
import { StockBatchStatusUpdateModel, StockItemModel, StockItemStatsModel, StockItemStatus } from '../../models/stock';

interface FormData {
  [key: string]: {[key: string]: number};
}

@Component({components: {}})
export class StockRevisionDialogButton extends Vue {
  @inject(DependencyIdentifiers.StockService)
  private stockService!: IStockService;
  @inject(DependencyIdentifiers.PatientService)
  private patientService!: IPatientService;

  @Prop() private label!: string;
  @Prop() private disableStorno!: boolean;
  @Prop() private disableReturn!: boolean;
  @Prop() private patient!: PatientModel;
  @Ref() form: any;

  private fillAvailable = -1;
  private fillReturn = -1;
  private items : {[key: string]: StockItemStatsModel} = {};
  private isLoading = false;
  private dialog = false;
  private componentKey = 0;

  private formData: FormData = {available: {}, possibly_used: {}};

  async open() {
    this.isLoading = true;
    this.items = {};
    await this.fetchStockStat();
  }

  async fetchStockStat() {
    await this.stockService.stats(1, -1, {patientId: this.patient.$id}, true)
      .then(([items, total]) => {
        items.forEach(item => {
          if (item.counters.possibly_used + item.counters.available < 1) { return; }
          const key = item.$drugId +  item.lotId;
          this.items[key] = item;
        });
      })
      .finally(() => this.isLoading = false);

    this.fillValues('available');
    this.fillValues('possibly_used');
  }

  async save(statusFrom: string, action: string) {
    this.isLoading = true;

    const queue: StockBatchStatusUpdateModel[] = [];
    const keys = Object.keys(this.items);
    for (let key of keys) {
      const item = this.items[key];
      // LOL. I mean. This is so fucked up. Having number typedef yet the actual value is string but
      // I have to jump through these fucking hoops to get my real-real number. Fuck you.
      const amount = parseInt((this.formData[statusFrom][key] || 0) as unknown as string);
      if (amount < 1) { continue; }
      const data: StockBatchStatusUpdateModel = {
        $patientId: this.patient.$id!,
        $drugId: item.$drugId,
        amount,
        lotId: item.lotId,
        statusFrom: statusFrom as StockItemStatus,
      }

      if (action === 'storno') { data.isStorno = true; }
      else { data.statusInto = action as StockItemStatus; }
      queue.push(data);
    }

    await this.stockService.batchUpdate(queue)
      .finally(() => {
        this.isLoading = false;
        this.$emit('saved');
        this.close();
      });
  }

  fillValues(status: string, isMax = false) {
    const keys = Object.keys(this.items);
    for (let key of keys) {
      this.formData[status][key] = isMax ? this.items[key].counters[status] : 0;
    }
    this.componentKey++;
  }

  hasLoadedData() {
    return !this.isLoading && Object.keys(this.items).length > 0;
  }

  @Emit('close')
  close() {
    this.dialog = false;
  }
}

export default StockRevisionDialogButton;
